import DOMPurify from "dompurify"

/**
 * Sanitize CMS/backend-supplied HTML before injecting it via
 * `dangerouslySetInnerHTML`. Strips <script>, event handlers (onerror/onclick…),
 * `javascript:` URLs, <iframe>, and every other XSS vector while keeping normal
 * rich-text markup (headings, paragraphs, links, lists, images, tables).
 *
 * Replaces the old hand-rolled regex "sanitizer" which missed unquoted handlers,
 * `javascript:` hrefs, <svg onload>, etc.
 */
export const sanitizeHtml = (dirty = "") =>
  DOMPurify.sanitize(String(dirty ?? ""), { USE_PROFILES: { html: true } })

/**
 * Return a URL only if it uses a safe scheme, else "#". Blocks `javascript:`,
 * `data:`, `vbscript:` etc. that a CMS-supplied href could carry (React does not
 * block those on its own). Relative URLs and http(s)/mailto/tel are allowed.
 */
export const safeHref = (url = "") => {
  const u = String(url ?? "").trim()
  if (!u) return "#"
  const scheme = u.match(/^([a-z][a-z0-9+.-]*):/i)
  if (scheme) {
    const s = scheme[1].toLowerCase()
    return s === "http" || s === "https" || s === "mailto" || s === "tel" ? u : "#"
  }
  return u // relative (/, #, ?, or scheme-less path)
}
